"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
const identities_1 = require("../sdk/identities");
const environment_1 = require("./environment");
const getLoginUrl = (inputPath, inputApp, inputPort) => {
    const path = inputPath
        ? encodeURIComponent(inputPath)
        : encodeURIComponent(window.location.pathname + window.location.search);
    const port = inputPort ? inputPort : window.location.port;
    const portString = port != '' && port != '443' ? '&port=' + port : '';
    const app = inputApp ? inputApp : environment_1.Environment.getAppName(window.location.hostname);
    return 'https://login.' + pplsi.realmDomain + '/login?app=' + app + portString + '&path=' + path;
};
const getAccountCreateUrl = (inputPath, inputApp, inputPort) => {
    const path = inputPath
        ? encodeURIComponent(inputPath)
        : encodeURIComponent(window.location.pathname + window.location.search);
    const port = inputPort ? inputPort : window.location.port;
    const portString = port != '' && port != '443' ? '&port=' + port : '';
    const app = inputApp ? inputApp : environment_1.Environment.getAppName(window.location.hostname);
    return 'https://login.' + pplsi.realmDomain + '/sign-up?app=' + app + portString + '&path=' + path;
};
const getReLoginUrl = (inputPath, inputApp, inputPort) => {
    // sub_type: User, Internal, Partner, Group
    // pplsi.realmdomain: e.g., dev-legalshield.com
    // pplsi.realm: member, internal, partner, group
    var _a, _b, _c, _d, _e, _f, _g;
    // Defaults: shield-service.com, pplsipeople.com, shieldproviders.com, shieldatwork.com
    const path = inputPath
        ? encodeURIComponent(inputPath)
        : encodeURIComponent(window.location.pathname + window.location.search);
    const port = inputPort ? inputPort : window.location.port;
    const portString = port != '' && port != '443' ? '&port=' + port : '';
    const app = inputApp ? inputApp : environment_1.Environment.getAppName(window.location.hostname);
    if ((((_a = pplsi.authNPayload) === null || _a === void 0 ? void 0 : _a.sub_type) === identities_1.Realm.User && pplsi.realm === 'member') ||
        (((_b = pplsi.authNPayload) === null || _b === void 0 ? void 0 : _b.sub_type) === identities_1.Realm.Internal && pplsi.realm === 'internal') ||
        (((_c = pplsi.authNPayload) === null || _c === void 0 ? void 0 : _c.sub_type) === identities_1.Realm.Partner && pplsi.realm === 'partner') ||
        (((_d = pplsi.authNPayload) === null || _d === void 0 ? void 0 : _d.sub_type) === identities_1.Realm.GroupAdmin && pplsi.realm === 'group')) {
        return 'https://login.' + pplsi.realmDomain + '/login?app=' + app + portString + '&path=' + path;
    }
    if (((_e = pplsi.authNPayload) === null || _e === void 0 ? void 0 : _e.sub_type) === identities_1.Realm.User) {
        return ('https://login.shield-service.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
    else if (((_f = pplsi.authNPayload) === null || _f === void 0 ? void 0 : _f.sub_type) === identities_1.Realm.Internal) {
        return ('https://login.pplsipeople.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
    else if (((_g = pplsi.authNPayload) === null || _g === void 0 ? void 0 : _g.sub_type) === identities_1.Realm.Partner) {
        return ('https://login.shieldproviders.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
    else {
        return ('https://login.shieldatwork.com.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
};
const redirectToLogin = () => {
    window.location.href = getLoginUrl();
};
const redirectToSignUp = () => {
    window.location.href = getAccountCreateUrl();
};
const redirectToReLogin = () => {
    window.location.href = getReLoginUrl();
};
const getLogoutUrl = () => {
    return 'https://login.' + realmDomain + '/logout';
};
exports.Login = {
    getAccountCreateUrl,
    getLoginUrl,
    getLogoutUrl,
    getReLoginUrl,
    redirectToLogin,
    redirectToReLogin,
    redirectToSignUp,
};
//# sourceMappingURL=login.js.map